import { toastService } from "../../../../providers";
import { extractAxiosErrorMessage } from "../../../../services/utils/errorUtils";

export const createAccountSubmitHandler = (
  mutateFn,
  prepareVariables,
  onSuccessCallback,
  accountType,
) => {
  const accountTypeMessages = {
    mobile: "Mobile money account added successfully",
    bank: "Bank account added successfully",
    wallet: "Paykit wallet account added successfully",
  };

  const accountTypeErrors = {
    mobile: "Failed to add mobile money account",
    bank: "Failed to add bank account",
    wallet: "Failed to add Paykit wallet account",
  };

  return (formValues) => {
    const trimmedValues = Object.entries(formValues).reduce(
      (acc, [key, value]) => {
        acc[key] = typeof value === "string" ? value.trim() : value;
        return acc;
      },
      {},
    );
    const mutationVariables = prepareVariables(trimmedValues);
    mutateFn(mutationVariables, {
      onSuccess: () => {
        toastService.success(
          accountTypeMessages[accountType] || "Account added successfully",
        );
        onSuccessCallback();
      },
      onError: (error) => {
        console.log("Error details:", error);
        toastService.error(
          extractAxiosErrorMessage(
            error,
            accountTypeErrors[accountType] || "Failed to add account",
          ),
        );
      },
    });
  };
};

export default createAccountSubmitHandler;
